module.exports = __webpack_public_path__ + "img/healthcard.c129c632.png";